import { OTCTraderTabs } from './otc-trader-tabs';

import './styles.scss';

const otcTrader = () => {
  return (
    <div className="otc-trader-container">
      <OTCTraderTabs />
    </div>
  );
};

export default otcTrader;
